import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { AppSyncClientUnauthenticated } from '../../backends/AppSyncClient';
import GetConfig from '../../q/GetConfig';
// import withContext from '../../context';

// class Configuration extends React.Component {
//   constructor(props) {
//     super(props);
//   }

//   // componentDidMount() {
//   //   const { context } = this.props;
//   //   context.config = this.props.getConfig;
//   // }

//   render() {
//     const { context } = this.props;
//     context.config = this.props.getConfig;
//     return (<></>);
//   }
// }

export default (Comp) => compose(
  graphql(GetConfig, {
    skip: (props) => !props.userHash || props.userHash === '---',
    props: (props) => { // eslint-disable-line arrow-body-style
      console.log('GetConfig');
      console.log(props);

      return {
        // ...props,
        config: props.data.getConfig || undefined,
      };
    },
    options: (props) => { // eslint-disable-line arrow-body-style
      // const user = await Auth.currentCredentials();
      // console.log('config user');
      // console.log(user);
      console.log('config userHash');
      console.log(props.userHash);

      return ({
        variables: {
          hash: props.userHash,
        },
        client: AppSyncClientUnauthenticated,
        fetchPolicy: 'cache-and-network',
      });
    },
    client: AppSyncClientUnauthenticated,
  })
)(Comp);
